import * as types from './types';
import * as reportsApi from 'services/api/report';
import i18n from 'i18n-js';
import { uiActions } from 'state/modules/UI';
import { getErrorMessage, parsePagination } from 'utils';

const fetchReportsRequest = (payload) => ({
  type: types.FETCH_REPORTS_REQUEST,
  payload,
});

const fetchReportsSuccess = (payload) => ({
  type: types.FETCH_REPORTS_SUCCESS,
  payload,
});

const fetchReportsFailed = (error) => ({
  type: types.FETCH_REPORTS_FAILED,
  error,
});

const fetchDefaultReportsRequest = (payload) => ({
  type: types.FETCH_DEFAULT_REPORTS_REQUEST,
  payload,
});

const fetchDefaultReportsSuccess = (payload) => ({
  type: types.FETCH_DEFAULT_REPORTS_SUCCESS,
  payload,
});

const fetchDefaultReportsFailed = (error) => ({
  type: types.FETCH_DEFAULT_REPORTS_FAILED,
  error,
});

const fetchReports = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchReportsRequest());

    const response = await reportsApi.fetchReports(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchReportsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    return dispatch(fetchReportsFailed());
  };
};

const fetchDefaultReports = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchDefaultReportsRequest());

    const response = await reportsApi.fetchDefaultReports(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchDefaultReportsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    return dispatch(fetchDefaultReportsFailed());
  };
};

// Get report by id

const sendReportToRequesterByIdRequest = (payload) => ({
  type: types.SEND_REPORT_TO_REQUESTER_BY_ID_REQUEST,
  payload,
});

const sendReportToRequesterByIdSuccess = (payload) => ({
  type: types.SEND_REPORT_TO_REQUESTER_BY_ID_SUCCESS,
  payload,
});

const sendReportToRequesterByIdFailed = (error) => ({
  type: types.SEND_REPORT_TO_REQUESTER_BY_ID_FAILED,
  error,
});

const sendReportToRequesterById = (id) => {
  return async (dispatch) => {
    dispatch(sendReportToRequesterByIdRequest());

    const response = await reportsApi.sendReportToRequesterById(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('reports.request_success'),
        })
      );
      return dispatch(
        sendReportToRequesterByIdSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    return dispatch(sendReportToRequesterByIdFailed());
  };
};

// Get send report to requester by id

const fetchReportByIdRequest = (payload) => ({
  type: types.FETCH_REPORT_BY_ID_REQUEST,
  payload,
});

const fetchReportByIdSuccess = (payload) => ({
  type: types.FETCH_REPORT_BY_ID_SUCCESS,
  payload,
});

const fetchReportByIdFailed = (error) => ({
  type: types.FETCH_REPORT_BY_ID_FAILED,
  error,
});

const fetchReportById = (id) => {
  return async (dispatch) => {
    dispatch(fetchReportByIdRequest());

    const response = await reportsApi.fetchReportById(id);

    if (response.ok) {
      return dispatch(
        fetchReportByIdSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    return dispatch(fetchReportByIdFailed());
  };
};

// Delete report by id

const deleteReportByIdRequest = (payload) => ({
  type: types.DELETE_REPORT_BY_ID_REQUEST,
  payload,
});

const deleteReportByIdSuccess = (payload) => ({
  type: types.DELETE_REPORT_BY_ID_SUCCESS,
  payload,
});

const deleteReportByIdFailed = (error) => ({
  type: types.DELETE_REPORT_BY_ID_FAILED,
  error,
});

const deleteReportById = (id) => {
  return async (dispatch) => {
    dispatch(deleteReportByIdRequest());

    const response = await reportsApi.deleteReportById(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('reports.delete_success'),
        })
      );
      return dispatch(
        deleteReportByIdSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    return dispatch(deleteReportByIdFailed());
  };
};

// Create Report
const createReportRequest = () => ({
  type: types.CREATE_REPORT_REQUEST,
});

const createReportSuccess = (payload) => ({
  type: types.CREATE_REPORT_SUCCESS,
  payload,
});

const createReportFailed = (payload) => ({
  type: types.CREATE_REPORT_FAILED,
  payload,
});

const createReport = (payload) => {
  return async (dispatch) => {
    dispatch(createReportRequest());

    const response = await reportsApi.createReport(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('reports.create_success'),
        })
      );
      return dispatch(createReportSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data);

    if (typeof formattedError === 'string') {
      dispatch(createReportFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: i18n.t('reports.create_failure'),
      })
    );

    return dispatch(createReportFailed(errors));
  };
};

// Update report by id

const updateReportRequest = () => ({
  type: types.UPDATE_REPORT_REQUEST,
});

const updateReportSuccess = (payload) => ({
  type: types.UPDATE_REPORT_SUCCESS,
  payload,
});

const updateReportFailed = (payload) => ({
  type: types.UPDATE_REPORT_FAILED,
  payload,
});

const updateReport = (id, payload) => {
  return async (dispatch) => {
    dispatch(updateReportRequest());

    const response = await reportsApi.updateReport(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('reports.update_success'),
        })
      );
      return dispatch(updateReportSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, {}, true);
    if (typeof formattedError === 'string') {
      dispatch(updateReportFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: i18n.t('reports.update_failure'),
      })
    );

    return dispatch(updateReportFailed(errors));
  };
};

// Download report by id and timestamp

const fetchReportsDownloadRequest = () => ({
  type: types.DOWNLOAD_REPORT_REQUEST,
});

const fetchReportsDownloadSuccess = (payload) => ({
  type: types.DOWNLOAD_REPORT_SUCESS,
  payload,
});

const fetchReportsDownloadFailed = () => ({
  type: types.DOWNLOAD_REPORT_FAILED,
});

const downloadReport = (id, report_ts) => {
  return async (dispatch) => {
    dispatch(fetchReportsDownloadRequest());
    const response = await reportsApi.downloadReport(id, report_ts);
    if (response.ok) {
      return dispatch(fetchReportsDownloadSuccess(response.data));
    }
    return dispatch(fetchReportsDownloadFailed());
  };
};

export {
  fetchReports,
  fetchDefaultReports,
  fetchReportById,
  deleteReportById,
  sendReportToRequesterById,
  createReport,
  updateReport,
  downloadReport,
  fetchReportsDownloadSuccess,
};
